<div class="panel panel-default margin-bottom-xs label-text" *ngIf="sitePlinks.length > 0">
	<div class="panel-body">
		<div>
			<div class="row padding-right-10 margin-bottom-sm">
				<div class="col-md-2 text-right-md margin-top"><strong>{{'act.select_plink'|translate}}:</strong></div>
				<div class="col-md-3 margin-top">
					<div class="form-field">
						<ng-select [items]="sitePlinks" bindLabel="prettyName" bindValue="deviceid" placeholder="{{'act.select_plink'|translate}}" name="plinkID" [(ngModel)]="plinkID" [clearable]="false" (ngModelChange)="plinkChanged()">
						</ng-select>
					</div>
				</div>
				<div class="col-md-2 col-xs-6 text-right-md margin-top">
					<strong *ngIf="plink.actviewenabled">{{'plink.lastconnecttime'|translate}}:<br/></strong>
					<strong *ngIf="userService.hasAccessFunction('view_rejected_device_connections') && plink.actviewenabled">{{'g.ip_address'|translate}}:<br/></strong>
					<strong *ngIf="!plink.actviewenabled && plink.lastuploadtime">{{'plink.last_upload_time'|translate}}:<br/></strong>
					<strong *ngIf="!plink.actviewenabled && plink.lastrecordtime">{{'plink.last_record_date'|translate}}:<br/></strong>
				</div>
				<div class="col-md-3 col-xs-6 margin-top">
					<span *ngIf="plink.actviewenabled">{{plink.lastconnecttime | date:'MM/dd/yyyy hh:mm:ss a'}}<br/></span>
					<span *ngIf="userService.hasAccessFunction('view_rejected_device_connections') && plink.actviewenabled">{{plink.ip_address ? plink.ip_address : 'No IP'}}<br/></span>
					<span *ngIf="!plink.actviewenabled && plink.lastuploadtime">{{plink.lastuploadtime | date:'MM/dd/yyyy hh:mm:ss a'}}<br /></span>
					<span *ngIf="!plink.actviewenabled && plink.lastrecordtime">{{plink.lastrecordtime | date:'MM/dd/yyyy hh:mm:ss a'}}<br/></span>
				</div>
				<div class="col-md-2" *ngIf="(activePage == 'analytics' || activePage == 'plink-events' || showElementsFlags.pageHasManageBtn) || (!multipleOptions && plinkID != 0)">
					<app-manage-device-btn [selectedDevices]="plinkID ? [plinkID] : []" [type]="'plink'" *ngIf="!userService.hasAccessFunction('no_manage_devices')"></app-manage-device-btn>
				</div>
				<div class="col-md-2" *ngIf="activePage == 'settings' && multipleOptions && plinkID != 0">
					<div class="btn-group pointer" appDropdown [indirectOptionsList]="true">
						<i type="button" class="btn btn-default glyphicon glyphicon-cog dropdown-toggle" dropdown-toggle></i>
						<app-plink-actions [plink]="plink" [siteID]="siteID"></app-plink-actions>
					</div>
				</div>
			</div>
			<div *ngIf="showDateRange" class="row margin-bottom-sm">
				<div class="col-md-2 text-right-md "><strong>{{'time.from_date'|translate}}:</strong></div>
				<div class="col-md-3">
					<div class="input-group">
						<input class="form-control" placeholder="mm/dd/yyyy" name="startDB" [(ngModel)]="fromDateFmt" (ngModelChange)="datesChanged()" bsDatepicker #startDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
						<span class="input-group-btn">
							<button class="btn btn-default btn-date" (click)="startDB.toggle()" type="button"><i class="fa fa-calendar"></i></button>
						</span>
					</div>
				</div>
				<div class="col-md-2 text-right-md "><strong>{{'time.to_date'|translate}}:</strong></div>
				<div class="col-md-3 ">
					<div class="input-group">
						<input class="form-control" placeholder="mm/dd/yyyy" name="endDB" [(ngModel)]="toDateFmt" (ngModelChange)="datesChanged()" bsDatepicker #endDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
						<span class="input-group-btn">
							<button class="btn btn-default btn-date" (click)="endDB.toggle()" type="button"><i class="fa fa-calendar"></i></button>
						</span>
					</div>
				</div>
				<div class="col-md-2">
					<!-- Placeholder for PolarLink-specific actions if needed -->
				</div>
			</div>
			<div *ngIf="plinkID > 0" class="row margin-bottom-sm">
				<div class="col-md-2 text-right-md ">
					<strong>{{'plink.plink_tags'|translate}}</strong>
				</div>
				<div class="col-md-3 ">
					<tags
						[items]="siteTags | values"
						[deviceType]="'plink'"
						[deviceId]="plinkID"
						[tag]="deviceTags[plinkID]"
						[customerId]="customerID"
						[siteId]="siteID"
						[isACTuser]="currentUser.isACTuser"
						(onUpdateTags)="updateTags($event)"
						>
					</tags>
				</div>
				<div class="col-md-2 text-right-md ">
					<!-- Placeholder for additional PolarLink info if needed -->
				</div>
				<div class="col-md-3 ">
					<!-- Placeholder for additional PolarLink controls if needed -->
				</div>
				<div class="col-md-2"></div>
				<div class="col-md-2 text-right-md " *ngIf="currentSite.act_first_enabled">
					<strong>{{'site.groups'|translate}}</strong>
				</div>
				<div class="col-md-3 " *ngIf="currentSite.act_first_enabled">
					<groups
						[items]="siteGroups"
						[deviceType]="'plink'"
						[deviceId]="plinkID"
						[customerId]="customerID"
						[siteId]="siteID"
						[isACTuser]="currentUser.isACTuser"
						(onAddGroup)="addGroup($event)"
						>
					</groups>
				</div>
			</div>
		</div>
	</div>
</div>
